<template>
	<div
		v-if="config.items.length > 0"
		class="l-content-section krone-featured-nav"
	>
		<a
			v-for="item in config.items"
			:key="item.label"
			class="krone-featured-nav__link"
			:href="item.link"
		>
			<svg
				v-if="item.icon"
				class="krone-featured-nav__icon"
			>
				<use :href="item.icon" />
			</svg>
			{{ item.label }}
			<Icon
				icon-name="right-arrow-small"
				size="xxl"
				class="krone-featured-nav__arrow"
			/>
		</a>
	</div>
</template>

<script>
import Icon from '@shared/components/Icon';

export default {
	name:       'KroneFeaturedNav',
	components: { Icon },
	props:      {
		config: {
			type:     Object,
			required: true,
		},
	},
};
</script>

<style lang="scss" scoped>
@import '@sass/variables';

.krone-featured-nav {
	display: flex;
	flex-direction: column;
	align-items: stretch;
	width: 100%;
	gap: $sp3-5;

	@include size(md-up) {
		flex-direction: row;
		align-items: center;
	}
}

.krone-featured-nav__link {
	position: relative;
	display: flex;
	align-items: center;
	justify-content: flex-start;
	gap: $sp3-5;
	border: 2px solid var(--color-grey-800);
	border-radius: $border-radius--xl;
	background: linear-gradient(90deg, var(--color-grey-800) 0%, var(--color-black) 100%);
	padding: 0 $sp4;
	height: 64px; // stylelint-disable-line
	flex-grow: 1;
	font-weight: 700; // stylelint-disable-line
	font-size: 22px; // stylelint-disable-line
	transition: background $trans-time-fast;

	&:hover {
		background: linear-gradient(90deg, var(--color-grey-900) 0%, var(--color-black) 100%);
	}

	@include size(md-up) {
		justify-content: center;
		height: 80px; // stylelint-disable-line
		flex-basis: 33.33%;
	}
}

.krone-featured-nav__icon {
	width: 32px;
	height: 32px;
}

.krone-featured-nav__arrow {
	position: absolute;
	right: $sp4;
	top: 50%;
	transform: translateY(-50%);

	@include size(md-up) {
		display: none;
	}
}
</style>
